<template>
  <div>
    <p class="my-4">
      Preview
    </p>
    <div class=" flex rounded-md">
      <div class="shadow-md bg-white text-sm rounded-md relative">
        <div id="carthike-chat-widget" class="text-white w-64">
          <div
            class="chat-widget-header rounded-t-md p-4"
            :style="{ backgroundColor: config.colors.widgetHeaderColor }"
          >
            <div
              id="chat-widget-close-icon"
              class="chat-widget-close-btn absolute right-4"
              style="width: 20px;"
              :style="{ color: config.colors.widgetHeaderTextColor }"
            >
              <img
                style="display: table-row"
                src="https://cdn.shopify.com/s/files/1/0539/8446/0950/t/1/assets/close.svg?v=1614675365"
              />
            </div>
            <div
              class="chat-widget-title text-2xl"
              :style="{ color: config.colors.widgetHeaderTextColor }"
            >
              {{ config.texts.widgetTitle }}
            </div>
            <div
              class="chat-widget-description text-base"
              :style="{ color: config.colors.widgetHeaderTextColor }"
            >
              {{ config.texts.widgetDescription }}
            </div>
          </div>
          <div class="chat-cont text-black">
            <div>
              <div
                class="chat-list-cont flex p-4"
                v-for="(agent, index) in config.additionalAgents"
                :key="index"
              >
                <div class="chat-user-avatar">
                  <img
                    style="height: 55px; width: 55px; border-radius: 50%;"
                    class="avatar-theme-301"
                    :src="agent.avatarUrl"
                  />
                </div>
                <div class="chat-user-meta pl-2">
                  <div class="chat-user-name text-gray-600 capitalize text-lg">
                    {{ agent.name }}
                  </div>
                  <p class="chat-user-desc text-gray-400">
                    {{ agent.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WidgetPreview",
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
